import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MHeading } from '../../../styledComponents';
import { colors, fonts } from '../../../utils';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
const { colorPrimary, colorWhite, colorLightBlack, colorGradient } = colors;
const { primaryFont } = fonts;

function Header() {
	const navigate = useNavigate();

	const logoutHandler = async () => {
		try {
			await Api.post(endPoints.auth.logout);
		} catch (error) {
			console.error('Logout API error:', error);
		} finally {
			localStorage.clear();
			navigate(0);
		}
	};

	const changePasswordHandler = () => {
		navigate('/change-password/change');
		handleClose();
	};

	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const clearCacheData = () => {
		caches.keys().then((names) => {
			names.forEach((name) => {
				caches.delete(name);
			});
		});
		localStorage.clear()
		window.location.reload(false);

	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	return (
		<>
			{/* Material UI Box */}
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
				style={{
					// position: 'relative',
					// top: '13.5px',
					// background: colorPrimary,
					background: colorGradient,
					padding: '0.5rem 2rem',
					transition: '0.3s all ease-in',
					boxShadow: '0 1.6rem 3rem rgb(0 0 0 / 10%)',
					zIindex: '111',
					width: '98%',
					borderRadius: '1rem',
					margin: '1rem 1.5rem',
					height: '5rem',
				}}>
				<MHeading color={colorWhite} fs='1.8rem' className='font-face-M'>
					Portal
				</MHeading>

				<div>
					<IconButton
						aria-describedby={id}
						variant='contained'
						onClick={handleClick}
						aria-label='drop-down-menu'
						size='large'>
						<PersonIcon style={{ color: colorWhite, fontSize: '2.2rem' }} />
					</IconButton>
				</div>
			</Box>

			<Popover
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				sx={{
					'& .MuiPaper-root': {
						display: 'flex',
						flexFlow: 'column',
					},
					'& .MuiButtonBase-root': {
						padding: '1rem 1rem',
					},
				}}
				style={{}}>
				{/* <ListItemButton
					component='a'
					sx={{
						'& .MuiTypography-root': {
							fontSize: '1.4rem',
							fontFamily: primaryFont,
							fontWeight: 500,
						},
					}}
					onClick={() => changePasswordHandler()}>
					<PersonRoundedIcon
						style={{
							color: colorPrimary,
							fontSize: '2rem',
							marginTop: '-0.3rem',
							marginRight: '0.5rem',
						}}
					/>
					<ListItemText
						style={{
							textDecoration: 'none',
							color: colorLightBlack,
							marginTop: '3px',
						}}>
						Change Password
					</ListItemText>
				</ListItemButton> */}

				
				<ListItemButton
					component='a'
					sx={{
						'& .MuiTypography-root': {
							fontSize: '1.4rem',
							fontFamily: primaryFont,
							fontWeight: 500,
						},
					}}
					onClick={() =>navigate('/profile')}>
					<PersonIcon
						style={{
							color: colorPrimary,
							fontSize: '2rem',
							marginTop: '-0.3rem',
							marginRight: '0.5rem',
						}}
					/>
					<ListItemText
						style={{
							textDecoration: 'none',
							color: colorLightBlack,
							marginTop: '3px',
						}}>
						Profile
					</ListItemText>
				</ListItemButton>
				<ListItemButton
					component='a'
					sx={{
						'& .MuiTypography-root': {
							fontSize: '1.4rem',
							fontFamily: primaryFont,
							fontWeight: 500,
						},
					}}
					onClick={() => logoutHandler()}>
					<LogoutIcon
						style={{
							color: colorPrimary,
							fontSize: '2rem',
							marginTop: '-0.3rem',
							marginRight: '0.5rem',
						}}
					/>
					<ListItemText
						style={{
							textDecoration: 'none',
							color: colorLightBlack,
							marginTop: '3px',
						}}>
						Log out
					</ListItemText>
				</ListItemButton>
				<ListItemButton
					component='a'
					sx={{
						'& .MuiTypography-root': {
							fontSize: '1.4rem',
							fontFamily: primaryFont,
							fontWeight: 500,
						},
					}}
					onClick={() => clearCacheData()}>
					<DeleteForeverIcon
						style={{
							color: colorPrimary,
							fontSize: '2rem',
							marginTop: '-0.3rem',
							marginRight: '0.5rem',
						}}
					/>
					<ListItemText
						style={{
							textDecoration: 'none',
							color: colorLightBlack,
							marginTop: '3px',
						}}>
						Clear Cache
					</ListItemText>
				</ListItemButton>
			</Popover>
		</>
	);
}

export default Header;
